import React from "react";

export const XolaShortLogo = (props: any) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" fill="none" viewBox="0 0 150 150" {...props}>
            <rect width="150" height="150" fill="url(#paint0_diamond_1563_47543)" rx="16" />
            <path
                fill="#fff"
                d="M105.226 121.398h-9.5l-21.242-39.35-20.983 39.35H44l25.49-46.675L44.947 28h9.645l19.92 37.285L94.406 28h9.616L79.622 74.723l25.604 46.675z"
            />
            <defs>
                <radialGradient
                    id="paint0_diamond_1563_47543"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientTransform="rotate(33.469 -37.602 -19.52) scale(215.78 1356.83)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#1352C6" />
                    <stop offset="0.443" stopColor="#732CFD" />
                    <stop offset="0.607" stopColor="#732CFD" />
                    <stop offset="0.911" stopColor="#F34AFF" />
                    <stop offset="1" stopColor="#FFBA69" />
                </radialGradient>
            </defs>
        </svg>
    );
};
